import React, { useState } from "react";
import SingleTag from "../atoms/SingleTag";
import { Tag } from "../../database.types";
import styled, { useTheme } from "styled-components";
import Button from "../atoms/Button";

type TagsSectionProps = {
  tagList: Tag[];
  activeTagId: number | null | undefined;
  setActiveTagId: (tagId: number | null) => void;
  isLoading?: boolean;
};

const TagsSection = ({
  tagList,
  activeTagId,
  setActiveTagId,
  isLoading,
}: TagsSectionProps) => {
  const [showAll, setShowAll] = useState(false);

  const tagsToShow = !showAll ? tagList.slice(0, 9) : tagList;

  const theme = useTheme();

  return (
    <StyledTagsSection>
      <StyledTagsWrapper>
        {tagsToShow.map((tag) => (
          <SingleTag
            key={`tag_${tag.id}_${tag.created_at}`}
            id={tag.id}
            name={tag.name}
            created_at={tag.created_at}
            links_count={tag.links_count}
            withCount
            isActive={tag.id === activeTagId}
            onClick={() => {
              if (activeTagId === null) {
                setActiveTagId(tag.id);
              } else if (activeTagId === tag.id) {
                setActiveTagId(null);
              } else {
                setActiveTagId(tag.id);
              }
            }}
            disabled={isLoading}
          />
        ))}
      </StyledTagsWrapper>

      {!showAll ? (
        <Button
          text="Show all tags"
          onClick={() => setShowAll(true)}
          width="fit-content"
          padding="7px 10px"
          backgroundColor="transparent"
          color={theme.colors.white}
          withHover={false}
        />
      ) : (
        <Button
          text="Hide"
          onClick={() => setShowAll(false)}
          width="fit-content"
          padding="7px 10px"
          backgroundColor="transparent"
          color={theme.colors.white}
          withHover={false}
        />
      )}
    </StyledTagsSection>
  );
};

const StyledTagsSection = styled.section`
  padding: 10px 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const StyledTagsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: wrap row;
  gap: 10px 8px;
`;

export default TagsSection;
